import * as React from "react";

interface SpriteWrapperProperties {
	slug: string;
	className?: string;
	alt?: string;
}

export function StaffRoleIcon(props: SpriteWrapperProperties){
	return (
		<img 
		className={`staff-role-icon staff-role-icon-${props.slug}${props.className ? " " + props.className : ""}`} 
		alt={props.alt ? props.alt : undefined} 
		src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACAAQMAAAD58POIAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNpjYBgFo2AUjIJRMApGwSigLwAACIAAAcNXzB0AAAAASUVORK5CYII="
		/>
	)
}

export function StaffProfileIcon(props: SpriteWrapperProperties){
	return (
		<img 
		className={`staff-profile-icon staff-profile-icon-${props.slug}${props.className ? " " + props.className : ""}`} 
		alt={props.alt ? props.alt : undefined} 
		src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUAAAAFAAQMAAAD3XjfpAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAACNJREFUeNrtwQENAAAAwqD3T20PBxQAAAAAAAAAAAAAAAD8GjNAAAFkKDHzAAAAAElFTkSuQmCC"
		/>
	)
}

export function SocialMediaIcon(props: SpriteWrapperProperties){
	return (
		<img 
		className={`social-media-icon social-media-icon-${props.slug}${props.className ? " " + props.className : ""}`} 
		alt={props.alt ? props.alt : undefined} 
		src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACAAQMAAAD58POIAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNpjYBgFo2AUjIJRMApGwSigLwAACIAAAcNXzB0AAAAASUVORK5CYII="
		/>
	)
}

export function IdolFace(props: SpriteWrapperProperties){
	return (
		<img 
		className={`idol-nav-face idol-nav-face-${props.slug}${props.className ? " " + props.className : ""}`} 
		alt={props.alt ? props.alt : undefined} 
		src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACAAQMAAAD58POIAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAABlJREFUeNpjYBgFo2AUjIJRMApGwSigLwAACIAAAcNXzB0AAAAASUVORK5CYII="
		/>
	)
}